import { ChatSidebarTabs } from '../../../slices/chat/ChatSlice';
import {
  completeSession,
  endSession,
  fetchGreeting,
  skipGreeting,
} from '../../../slices/chat/ChatThunks';
import { endAnalyticsSession } from '../../../slices/SilverstripeAPISlice';
import VHTypeNavigation from './VHTypeNavigation';
import VhTypes from './VHTypes';

const VhFreeformV3Config = {
  type: VhTypes.FREEFORM_V3,
  navigationLocations: [
    VHTypeNavigation.DETAILS,
    VHTypeNavigation.EVALUATIONS,
    VHTypeNavigation.AI_FALLBACKS,
    VHTypeNavigation.PREVIEW,
    VHTypeNavigation.COMPLETIONS,
    VHTypeNavigation.ANALYTICS,
    VHTypeNavigation.OBJECTIVES_ANALYTICS,
    VHTypeNavigation.SESSIONS,
  ],
  usesSessionReportAsScore: true,
  finishButtonText: (vhDBVh) => 'endConversation',
  finishPromptText: (vhDBVh) => 'proceed',
  endsConversationPromptText: (vhDBVh) => 'endConversationPromptText',
  postObjectivesCompletePromptText: (vhDBVh) => `completedObjectivesPrompt`,
  finishWarningText: (vhDBVh) => 'finishWarningText',
  onFinishSession: (dispatch, vhDBVH) => {
    dispatch(
      completeSession({
        patientId: vhDBVH.id,
      })
    );
  },
  onFinalResultsSaved: (dispatch) => {
    dispatch(endAnalyticsSession());
    dispatch(endSession());
  },
  getGreetingThunk: (vhDBVH) =>
    vhDBVH?.skipGreeting ? skipGreeting : fetchGreeting,
  chatSidebarTabs: {
    CHAT: ChatSidebarTabs.CHAT,
    ACTIONS: ChatSidebarTabs.ACTIONS,
    RESULTS: ChatSidebarTabs.RESULTS,
  },
  showHints: false,
  actionIcon: 'vh-actions',
  sidebarVisibleAtStart: false,
  usesCondition: false,
  usesDialogflow: false,
  canChangeLocale: true,
  usesObjectives: false,
  usesEvaluations: true,
  allowsUserLanguageChange: true,
  showAIFallbackBrain: false,
};
export default VhFreeformV3Config;
